export default __webpack_public_path__ + "static/Research-9d4afbc22943700a0862a41d843cb13d.svg";